<template>
  <div>
    <div class="col-12" v-if="!getEnvelopeMLALoading">
      <p style="font-weight: 700">Please sign the lease documents.</p>
      <DigitalSignAccount
        :name="primaryApplicantIDScanResult ? primaryApplicantIDScanResult.firstName + ' ' + primaryApplicantIDScanResult.lastName : ''"
        :buttonCondition="isUserPrimaryApplicant && !isPrimaryApplicantSigned"
        :buttonLoading="primaryApplicantLoading"
        :listCondition1="isPrimaryApplicantSigned"
        :listCondition2="!isUserPrimaryApplicant && !isPrimaryApplicantSigned"
        @onClickSignButton="onClickSignButton('primary')"
      />
      <DigitalSignAccount
        v-if="hasSecondaryApplicant && hasSecondaryApplicant == 'yes' && secondaryApplicant"
        :name="
          secondaryApplicantIDScanResult
            ? capitalizeFirstLetter(secondaryApplicantIDScanResult.firstName) +
              ' ' +
              capitalizeFirstLetter(secondaryApplicantIDScanResult.lastName)
            : ''
        "
        :buttonCondition="!isUserPrimaryApplicant && !isSecondaryApplicantSigned"
        :buttonLoading="secondaryApplicantLoading"
        :listCondition1="isSecondaryApplicantSigned"
        :listCondition2="isUserPrimaryApplicant && !isSecondaryApplicantSigned"
        @onClickSignButton="onClickSignButton('secondary')"
      />

      <DigitalSignWitness v-if="isWitnessExist" name="Witness" :listCondition1="isWitnessSigned" :listCondition2="!isWitnessSigned" />
    </div>

    <div v-if="getEnvelopeMLALoading" style="text-align: center; padding-top: 75px; padding-bottom: 75px">
      <p>Fetching status of signatures...</p>
      <QSpinner color="primary" size="5em" />
    </div>
    <QDialog v-model="showDocusign" full-width full-height>
      <QCard>
        <iframe :src="docusignUrl" style="width: 100%; height: calc(100% - 60px)" v-if="docusignUrl"></iframe>
        <div v-else class="flex justify-center items-center q-pa-md" style="width: 100%; height: calc(100% - 60px)">
          <QSpinner size="md" color="grey-7" />
        </div>
        <div class="text-center">
          <QBtn color="primary" no-caps @click="onCancel()" id="cancelButtonId">Cancel</QBtn>
        </div>
      </QCard>
    </QDialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { QBtn, QDialog, QCard, QSpinner } from 'quasar';
import MyCustomFunctions from '../../mixins/MyCustomFunctions.js';
import DigitalSignAccount from '../../components/Atoms/DigitalSignAccount';
import DigitalSignWitness from '../../components/Atoms/DigitalSignWitness';
import MutateGetEnvelopeMLA from '../../graphql/mutations/MutateGetEnvelopeMLA';
import MutateGetMLADocusign from '../../graphql/mutations/MutateGetMLADocusign';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';

export default {
  name: 'DigitalModule',
  mixins: [MyCustomFunctions],
  components: {
    QBtn,
    QDialog,
    QCard,
    QSpinner,
    DigitalSignAccount,
    DigitalSignWitness
  },
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard,
      vehicleApplication: (state) => state.vehicleApplication.vehicleApplication
    }),
    ...mapGetters({
      isUserPrimaryApplicant: 'vehicleApplication/isUserPrimaryApplicant'
    }),
    primaryApplicant() {
      return this.scoreboard?.primaryApplicant ? this.scoreboard?.primaryApplicant : null;
    },
    primaryApplicantIDScanResult() {
      return this.scoreboard?.primaryApplicant?.idScanResult ? this.scoreboard?.primaryApplicant.idScanResult : null;
    },
    secondaryApplicant() {
      return this.scoreboard?.secondaryApplicant ? this.scoreboard?.secondaryApplicant : null;
    },
    secondaryApplicantIDScanResult() {
      return this.scoreboard?.secondaryApplicant?.idScanResult ? this.scoreboard?.secondaryApplicant.idScanResult : this.secondaryApplicant;
    },
    entityDetails() {
      return this.scoreboard?.entityDetails ? this.scoreboard?.entityDetails : null;
    },
    hasPersonalGuarantee() {
      if (
        this.scoreboard &&
        this.scoreboard.businessDetails &&
        this.scoreboard.businessDetails.financeDetails &&
        this.scoreboard.businessDetails.financeDetails.personalGuarantee === 'yes'
      )
        return true;
      else return false;
    },
    hasPersonalGuaranteeUploaded() {
      if (
        this.scoreboard &&
        this.scoreboard.wetSignature &&
        this.scoreboard.wetSignature.documentPCA &&
        this.scoreboard.wetSignature.documentPCA.uploadFile &&
        this.scoreboard.wetSignature.documentPCA.uploadFile.uuid
      )
        return true;
      else return false;
    },
    hasSecondaryApplicant() {
      return this.scoreboard?.entityDetails?.hasSecondaryApplicant ? this.scoreboard?.entityDetails?.hasSecondaryApplicant : null;
    },
    isPrimaryApplicantSigned() {
      if (this.primaryApplicant && this.signers.length) {
        for (var i = 0; i < this.signers.length; i++) {
          if (this.signers[i].email == this.primaryApplicant.email && this.signers[i].status === 'completed') return true;
        }
      }
      return false;
    },
    isSecondaryApplicantSigned() {
      if (this.secondaryApplicant && this.signers.length) {
        for (var i = 0; i < this.signers.length; i++) {
          if (this.signers[i].email == this.secondaryApplicant.email && this.signers[i].status === 'completed') return true;
        }
      }
      return false;
    },
    isWitnessSigned() {
      if (this.witnesses.length) {
        for (var i = 0; i < this.witnesses.length; i++) {
          if (this.witnesses[i].roleName == 'Witness' && this.witnesses[i].status === 'completed') return true;
        }
      }
      return false;
    },
    isWitnessExist() {
      if (this.witnesses.length) {
        for (var i = 0; i < this.witnesses.length; i++) {
          if (this.witnesses[i].roleName == 'Witness') return true;
        }
      }
      return false;
    }
  },
  data: function () {
    return {
      showDocusign: false,
      docusignUrl: null,
      primaryApplicantLoading: false,
      secondaryApplicantLoading: false,
      getEnvelopeMLALoading: false,
      signers: [],
      witnesses: []
    };
  },
  created() {
    this.triggerGetEnvelopeMLA();
  },
  methods: {
    triggerGetEnvelopeMLA: async function () {
      this.getEnvelopeMLALoading = true;

      const response = await this.$apollo
        .mutate({
          mutation: MutateGetEnvelopeMLA,
          variables: {
            applicationId: this.vehicleApplication.applicationId
          }
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });

      if (response && response.data && response.data.getEnvelopeMLA && response.data.getEnvelopeMLA.status) {
        this.signers = response.data.getEnvelopeMLA.status.signers;
        this.witnesses = response.data.getEnvelopeMLA.status.witnesses;

        if (this.witnesses.length == 0) {
          if (this.signers.length == 1 && this.isPrimaryApplicantSigned) await this.onCompletion();
          else if (this.signers.length == 2 && this.isPrimaryApplicantSigned && this.isSecondaryApplicantSigned) await this.onCompletion();
        }

        if (this.witnesses.length && this.signers.length) {
          let witnessesCompleted = 0;
          let signersCompleted = 0;

          for (var i = 0; i < this.witnesses.length; i++) {
            if (this.witnesses[i].status === 'completed') witnessesCompleted++;
          }

          for (var i = 0; i < this.signers.length; i++) {
            if (this.signers[i].status === 'completed') signersCompleted++;
          }

          if (this.witnesses.length == witnessesCompleted && this.signers.length == signersCompleted) await this.onCompletion();
        }
      }

      this.getEnvelopeMLALoading = false;
    },
    onClickSignButton: async function (type) {
      if (type === 'secondary') await this.onSecondaryApplicantSign();
      else {
        if (this.hasPersonalGuarantee && !this.hasPersonalGuaranteeUploaded) return alert('Please upload The Personal Guarantee at first!');
        await this.onPrimaryApplicantSign();
      }
    },
    onPrimaryApplicantSign: async function () {
      this.primaryApplicantLoading = true;
      await this.onClickSign();
      this.primaryApplicantLoading = false;
    },
    onSecondaryApplicantSign: async function () {
      this.secondaryApplicantLoading = true;
      await this.onClickSign();
      this.secondaryApplicantLoading = false;
    },
    onClickHandler: function () {
      this.$router.push({ name: 'logout' });
    },
    onClickSign: async function () {
      this.showDocusign = true;
      return await this.$apollo
        .mutate({
          mutation: MutateGetMLADocusign,
          variables: {
            applicationId: this.vehicleApplication.applicationId,
            isCurrentUserPrimary: this.isUserPrimaryApplicant,
            returnUrl: `${location.protocol}//${window.location.host}/applications/${this.vehicleApplication.applicationId}/quotesign-mla`
          }
        })
        .then((data) => {
          this.docusignUrl = data.data.getMLADocusign.url;
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
    },
    onCancel: function () {
      this.showDocusign = false;
      this.docusignUrl = null;
      this.triggerGetEnvelopeMLA();
    },
    onCompletion: async function () {
      this.getEnvelopeMLALoading = true;

      await this.updateVehicleApplication('finished', 'status');

      if (this.hasSecondaryApplicant) {
        await this.updateVehicleApplication('finished', 'statusSecondary');
      }

      this.$router.push({ name: 'applications', params: { applicationId: this.vehicleApplication.applicationId } });

      this.getEnvelopeMLALoading = false;
    }
  }
};
</script>
